import { render } from "./MbaMarktHrm.vue?vue&type=template&id=6f016556"
import script from "./MbaMarktHrm.vue?vue&type=script&lang=js"
export * from "./MbaMarktHrm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__